'use strict';

angular.module('ClinicApp').directive('primaryPhoto', function($q, OCPhotoUtil, OCModalUtil, ClinicConfig, CurrentUser) {
  return {
    templateUrl: '/views/directives/_primary-photo.html',
    scope: {
      model: '=',
      modelType: '=',
      local: '=',
      photo: '=?',
    },
    link: function($scope, el) {
      var inputEl = el.find('input')[0];
      var imgEl = el.find('img')[0];
      var resourceURI = ClinicConfig.HOSTNAME + '/' + $scope.modelType + '/' + $scope.model.id + '/photo/primary';
      var cropOptionsByModelType = {
        clinic: {
          areaType: 'square',
          cropToggle: false,
        },
        doctor: {
          areaType: 'circle',
          cropToggle: false,
        },
      };

      imgEl.src = OCPhotoUtil.primaryPhotoForModel($scope.modelType, $scope.model.primaryPhoto);

      // Using low-level binding because `ng-click` throws an exception here because of `inputEl.click()`.
      el.find('.editable-primary-photo').on('click', function() {
        if (navigator.appVersion.search('MSIE 8') != -1 || navigator.appVersion.search('MSIE 9') != -1) {
          OCModalUtil.showModal(
            'error',
            'Photo upload is not supported on Internet Explorer 8 and 9.',
          );
        } else {
          inputEl.click();
        }
      });

      $scope.selectPhoto = function(files) {
        // Reset the input, so if the same file is chosen, the on-change fires.
        inputEl.value = '';

        if (_.isEmpty(files) || $scope.loading) {
          return;
        }

        OCPhotoUtil.readAsDataURI(files[0])
          .then((dataURI) => {
            return OCPhotoUtil.photoSizeDataURI(dataURI).then((size) => {
              if (size.width < 200 || size.height < 200) {
                OCModalUtil.showModal(
                  'error',
                  'Please select an image that is larger than 200x200 pixels.',
                );
                return $q.reject();
              }
              return OCModalUtil.showCustomModal({
                templateUrl: '/views/modals/_primary-photo-crop.html',
                controller: 'ModalPrimaryPhotoCrop',
                backdrop: 'static', // Prevent clicking outside from closing the modal.
                resolve: OCModalUtil.createResolve({
                  photo: dataURI,
                  options: cropOptionsByModelType[$scope.modelType],
                }),
              });
            });
          })
          .then((croppedDataURI) => {
            if ($scope.local) {
              imgEl.src = croppedDataURI;
              $scope.photo = croppedDataURI;
              return $q.reject();
            }
            $scope.loading = true;
            return OCPhotoUtil.uploadPhotoDataURI(resourceURI, croppedDataURI);
          })
          .then((response) => {
            const primaryPhotoPath = OCPhotoUtil.primaryPhotoForModel($scope.modelType, response.data);
            imgEl.src = primaryPhotoPath;
            $scope.photo = primaryPhotoPath;
            CurrentUser.update(); // Update the navigation bar.
            $scope.$emit('reload' + _.capitalize($scope.modalType));
          })
          .finally(() => {
            $scope.loading = false;
          });
      };
    },
  };
});
